import {
  InfoLink,
  InfoParagraph,
  InfoSection,
  PublicInfoShell
} from "@/components/PublicInfoShell";

export default function SupportRoute() {
  return (
    <PublicInfoShell
      eyebrow="Family support"
      title="How can we help?"
      intro="Help with signing in, finding a recital, watching on another device, casting to a television, or managing family access."
    >
      <InfoSection title="Contact support">
        <InfoParagraph>Email <InfoLink href="mailto:recitalmaster@gmail.com">recitalmaster@gmail.com</InfoLink> from the address connected to your family account. Include the recital name and the device you are using, but never send a password or payment-card number.</InfoParagraph>
      </InfoSection>

      <InfoSection title="Signing in">
        <InfoParagraph>Enter the email address connected to your recital access. Recital Master sends a secure sign-in link to that inbox. If you requested the link on another device, approve the named device from the email and return to the app.</InfoParagraph>
      </InfoSection>

      <InfoSection title="Playback and casting">
        <InfoParagraph>For playback trouble, confirm that the device has a stable connection, close any other active recital stream, and reopen the selected dance. For AirPlay or Google Cast, keep the phone and television on the same local network.</InfoParagraph>
      </InfoSection>

      <InfoSection title="Devices and family access">
        <InfoParagraph>The Account screen shows registered devices and current access status. Removing an old device makes room for a new phone, tablet, computer, or browser profile.</InfoParagraph>
      </InfoSection>

      <InfoSection title="Account deletion">
        <InfoParagraph>For permanent account deletion and details about what is removed, visit the <InfoLink href="/delete-account">account deletion page</InfoLink>.</InfoParagraph>
      </InfoSection>
    </PublicInfoShell>
  );
}
